import React from "react";
import cn from "classnames";
import ImagePrepare from "@elements/imagePrepare";
import { IWrappingInput } from "@types";
import { useAppContext } from "@context/app";
import { convertStringNumber } from "@utils/digits";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";

interface Props {
  balloon: IWrappingInput;
  count: number;
  canInc: boolean;
  canDec: boolean;
  onInc: () => void;
  onDec: () => void;
}

const BalloonItem: React.FC<Props> = ({ balloon, count, canInc, canDec, onInc, onDec }) => {
  const { decimal, currency } = useAppContext();
  const { locale } = useRouter();
  const t = useTranslations();

  return (
    <div className="w-1/2 sm:w-1/3 p-2">
      <div className="w-full rounded-2xl border border-[#EEE] overflow-hidden">
        <div className="w-full h-[120px] relative bg-[#F7F7F7]">
          <div className="absolute inset-0">
            <ImagePrepare media={balloon.media} alt={balloon.name} width={400} />
          </div>

          <div className="absolute bottom-2 left-2 right-2">
            <div className="flex items-center justify-between rounded-full border border-[#EEE] bg-white/90 backdrop-blur px-3 h-10">
              <button
                type="button"
                className={cn("text-xl leading-none", !canDec && "opacity-40")}
                disabled={!canDec}
                onClick={onDec}
              >
                -
              </button>
              <p className="text-sm font-bold text-[#333]">{count}</p>
              <button
                type="button"
                className={cn("text-xl leading-none", !canInc && "opacity-40")}
                disabled={!canInc}
                onClick={onInc}
              >
                +
              </button>
            </div>
          </div>
        </div>
      </div>
      <p className="text-center text-[#999] text-sm font-normal mt-2 left-to-right">
        {balloon.price.price ? (
          <>
            <span style={{ direction: "rtl" }} className="text-left">
              {currency}{" "}
            </span>{" "}
            <span className="px-1">
              {convertStringNumber(locale, balloon.price.price.toFixed(decimal))}
            </span>
          </>
        ) : (
          null
        )}
      </p>
    </div>
  );
};

export default BalloonItem;
